import { biLoggerFactory } from 'wix-private';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

const msid = '466c067a-f818-40bd-9047-065efe24c8c4';

/**
 * biGroupsLoggers it's an Object with key:value pair
 * key: represents src of the BI group
 * value: represents the biLogger function for that group
 * */

const biGroupsLoggers = {
    // src: biLoggerFactory(group, src, { msid }),
    19: biLoggerFactory('blog', 19, { msid }),
    69: biLoggerFactory('blog-app-uou', 69, { msid })
}

export async function fireBIEvent(src, evid, fields) {

    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}

/**
 * 
 
export async function firePostSurveyAnswerBI(app_url = '', button_text = '') {
    const biLogger = biLoggerFactory('blog', 19, { msid });
    try {
        const biEventObject = {
            evid: 401,
            app_url,
            button_text
        }
        await biLogger.log(biEventObject);
        console.log("fired with:", biEventObject)
    } catch (err) {
        console.error(`errSrc: Public/BIEventsFunctions - firePostSurveyAnswerBI, err: ${err}`);
    }

}

export function fireSubscribeBI(button_name) {
    const biLogger = biLoggerFactory('blog', 19, { msid });
    const biEventObject = {
        evid: 402,
        button_name,
        topic: 'Wix Blog',
        url: wixLocation.url
    }
    biLogger.log(biEventObject);
}

export function fireCategoryOpenBI(category_id, category_name) {
    const biLogger = biLoggerFactory('blog-app-uou', 69, { msid });
    const biEventObject = {
        app_id: '',
        evid: 201,
        biToken: msid,
        category_id,
        category_name,
        // community_id,
        // instance_id,
        // member_id,
        origin: 'categories_page',
        referral_info: wixWindow.referrer,
        // role,
        // site_member_id,
        // visitor_id
    }
    biLogger.log(biEventObject);

}
*/